import getInstantWinCardDetail from "./getInstantWinCardDetail.api";
import getAvailableInstantWinDropdown from "./getAvailableInstantWinDropdown.api";

const instantWinApi = {
  getInstantWinCardDetail,
  getAvailableInstantWinDropdown,
};

export default instantWinApi;
